// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] + "." + {"72":"3d16d370","187":"22ed1fbf","344":"c6b76ece"}[chunkId] + ".chunk.js";
};